import * as React                   from 'react';

import { Button                   } from 'src/components/common/button';
import { TagItem,
         Tags                     } from 'src/components/common/tags';
import { VGap                     } from 'src/components/common/flex/vgap';
import { HStack                   } from 'src/components/common/date-label/ui';
import { InputMultiline           } from 'src/components/common/input/input-multiline';

import { Container, 
         Caption,
         Message,
         SelectionRatingVariants,
         selectionrating_variants } from 'src/components/features/main/shade-selection/selection-rating/ui';



type Props = {
  variant: SelectionRatingVariants;
  onAccept: (isYes: boolean, note: string) => void;
  onCancel: () => void;
}
export const SelectionRating: React.FC<Props> = ({
  variant,
  onAccept,
  onCancel
}) => {
  const lookAndFeel = selectionrating_variants.get(variant)!;

  const [answer, setAnswer] = React.useState<string>('YES');
  const [note, setNote] = React.useState<string>('');

  const isDisabled = answer === 'NO' && note.trim() === '';

  const items: TagItem[] = [{ id: 'YES', label: 'Да' }, { id: 'NO', label: 'Нет' }];
  const value = items.find((item) => item.id === answer)!;

  const onTagsChangeHandler = (value: TagItem[]) => {
    setAnswer(value[1].id);
  }

  return (
    <Container lookAndFeel = { lookAndFeel }>
      <Caption lookAndFeel = { lookAndFeel }>
        Вы удовлетворены результатом подбора?
      </Caption>
      <VGap size = { 12 } />
      <Tags
        variant = { lookAndFeel.tagsVariant }
        items = { items }
        value = { [value] }
        onChange = { onTagsChangeHandler }
      />
      <VGap size = { 12 } />
      <Message lookAndFeel = { lookAndFeel }>
        Если результат подбора некорректный, то подробно опишите, почему так считаете. Это поможет нам стать лучше.
      </Message>
      <VGap size = { 16 } />
      <InputMultiline
        variant = { lookAndFeel.multilineVariant }
        maxLength = { 2000 }
        placeholder = 'Введите сообщение'
        value = { note }
        onChange = { setNote }
      />
      <VGap size = { 32 } />
      <HStack>
        <Button
          variant = { lookAndFeel.cancelButtonVariant }
          label = 'Отмена'
          onTap = { onCancel }
        />
        <Button
          variant = { lookAndFeel.sendButtonVariant }
          label = 'Отправить'
          isDisabled = { isDisabled }
          onTap = { () => onAccept(answer === 'YES', note.trim()) }
        />
      </HStack>
    </Container>
  );
};
